module.exports = ".kan-home {\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 0 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  @media screen and (max-width: 450px) {\n    .kan-home {\n      padding: 0; } }\n  .kan-home .kan-tabs {\n    width: 100%; }\n  .kan-home .kan-tabs .kan-tab-content {\n      width: 100%;\n      height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/home/component.scss
// module id = ./src/modules/main/components/home/component.scss
// module chunks = main